import { gql } from '@apollo/client';

export const REMOVE_TOUR = gql`
  mutation ($id: String!) {
    removeTour(id: $id)
  }
`;
